<template>
    <div class="list">
        <loading :isLoading="isLoading" />
        <div class="alert-wrapper">
            <alert-container :messages="msgs" />
        </div>
        <div class="filters-bar mb-3">
            <div class="filters-bar-form form-columns-fit">
                <div class="columns">
                    <div class="column is-4">
                        <search-bar
                            :onSearch="debouncedOnSearch"
                            ref="search"
                            tooltipLabel="msg-busca-listagem"
                        />
                    </div>
                    <div class="column is-4">
                        <label v-text="$t('empresa')" />
                        <vss-select
                            ref="empresaSelect"
                            class="smaller no-clear"
                            :value="empresaSelected"
                            :options="empresaList"
                            :height="40"
                            :loading="empresaLoading"
                            @search="carregarEmpresas"
                            @input="updateEmpresa"
                            label="rsocial"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                            searchable
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                    <div class="column is-4">
                        <vss-select
                            ref="colaboradorSelect"
                            class="smaller no-clear"
                            :value="colaboradorSelected"
                            :options="colaboradorList"
                            :height="40"
                            :loading="colaboradorLoading"
                            label="nome"
                            @search="carregarColaboradores"
                            @input="updateColaborador"
                            title="colaborador"
                            tooltipLabel="msg-associacao-empresa-colaborador"
                            :closeOnSelect="false"
                            no-clearfix
                            multiple
                            clearable
                            searchable
                        >
                            <template #multiple-selected="{ selected }">
                                ({{
                                    selected && selected.length > 0 ? selected.length : $t('todos')
                                }})
                            </template>
                        </vss-select>
                    </div>
                </div>
            </div>
            <div class="filters-bar-actions">
                <div class="filter-options">
                    <b-button
                        class="mr-2"
                        type="is-primary"
                        icon-right="filter"
                        @click="showFilter = !showFilter"
                        v-tippy
                        :title="$t('filtros')"
                    />
                </div>
                <div class="filter-options" v-if="permissao.update">
                    <b-button
                        class="mr-2"
                        type="is-primary"
                        icon-right="pencil"
                        @click="showParametrizacao = !showParametrizacao"
                        v-tippy
                        :title="$t('selecao-campos')"
                    />
                </div>
                <div class="filter-options">
                    <b-button
                        type="is-primary"
                        icon-right="view-week"
                        @click="ChangeTokanban()"
                        v-tippy
                        :title="$t('formato-kanban')"
                    />
                </div>
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty || !started" key="isEmpty" />
            <empty-table-message
                msg="nenhuma-coluna-ativa"
                v-else-if="this.table_fields.length == 0 && started"
                key="nenhuma-coluna-ativa"
            >
                <template v-slot:footer="">
                    <b-button
                        class="mt-2"
                        type="is-primary"
                        icon-left="pencil"
                        @click="showParametrizacao = !showParametrizacao"
                        :disabled="isLoading"
                    >
                        {{ $t('selecao-campos') }}
                    </b-button>
                </template>
            </empty-table-message>
            <b-table
                v-else
                class="data-table"
                :data="atendimentoList"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in table_fields"
                    :key="i"
                    :field="f.key"
                    :label="f.label ? $t(f.label) : ''"
                    :sortable="f.sortable"
                >
                    <template v-slot="props">
                        <div v-if="f.key == 'situacao'">
                            <span
                                v-if="props.row['situacao'] == 0"
                                class="clickable"
                                @click="showModalEdit(props.row.uuid)"
                                v-tippy
                                :title="$t('em-preenchimento') + ' - ' + $t('editar')"
                            >
                                <b-icon icon="pencil" type="is-primary" />
                            </span>

                            <b-icon
                                v-else
                                icon="check-circle"
                                type="is-success"
                                v-tippy
                                :title="$t('finalizado')"
                            />
                        </div>
                        <div v-else-if="f.key == 'codigo'">
                            <b>
                                <router-link
                                    :title="$t('visualizar')"
                                    :to="{
                                        name: 'ven-atendimento-edit',
                                        params: { uuid: props.row.uuid },
                                    }"
                                >
                                    {{ props.row[f.key] ? props.row[f.key] : '---' }}
                                </router-link>
                            </b>
                        </div>
                        <div v-else-if="f.key == 'data-do-atendimento'">
                            {{ props.row[f.key] ? $moment(props.row[f.key]).format('L') : '---' }}
                        </div>
                        <div v-else-if="f.key == 'finalizado-em'">
                            {{
                                props.row.datahoraFinalizado != undefined
                                    ? $moment(
                                          props.row.datahoraFinalizado,
                                          'DD/MM/YYYY HH:mm:ss'
                                      ).format('L LT')
                                    : '---'
                            }}
                        </div>
                        <div v-else-if="f.key == 'filtro-geolocalizacao'">
                            <div
                                v-if="permissao.read && containsLocation(props.row)"
                                class="has-text-centered"
                                @click="openLocationEditor(props.row)"
                                v-tippy 
                                :title="$t('check-in')"
                            >
                                <b-icon icon="map-marker" class="location-icon" />
                            </div>
                            <span v-else> --- </span>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] ? props.row[f.key] : '---' }}
                        </div>
                    </template>
                </b-table-column>
            </b-table>
        </div>
        <PaginationViewer
            v-if="!isEmpty"
            class="mb-0"
            :resetPagination="pagination.resetPagination"
            :totalItems="pagination.totalRows"
            :perPageOptions="pagination.perPageOptions"
            :optionStarted="pagination.optionStarted"
            @change="updatePagination"
        />

        <parametrizacao-campos
            codigounicotela="ven-atendimento"
            :showParametrizacao="showParametrizacao"
            @fecharModal="showParametrizacao = false"
            @table_fields="table_fields = $event"
        />

        <lateral-content v-model="showModalAtendimentoManage" v-if="uuid != undefined">
            <AtendimentoManage
                class="manage-content"
                v-if="showModalAtendimentoManage"
                cameFrom="AtendimentoKanban"
                :uuidFrom="uuid"
                @saved="
                    carregarDados();
                    showModalAtendimentoManage = false;
                "
                @voltar="showModalAtendimentoManage = false"
            />
        </lateral-content>
        <MapasGoogleMapsModal
            v-if="permissao.update"
            :center="center"
            :locationEditorOpen="locationEditorOpen"
            :update="true"
            @onCancelLocationEditor="onCancelLocationEditor"
            :showSaveButton="false"
        />
        <lateral-content :isLoading="isLoading" v-model="showFilter" footer>
            <template v-slot:footer-right="{ id }">
                <b-button
                    type="is-warning is-silver"
                    icon-right="backspace"
                    @click="onClearFilters()"
                    class="mr-2"
                    :disabled="isLoading"
                >
                    {{ $t('limpar') }}
                </b-button>
                <b-button
                    type="is-primary"
                    icon-right="filter"
                    @click="pesquisar()"
                    :disabled="isLoading"
                >
                    {{ $t('filtrar') }}
                </b-button>
            </template>
            <FiltroAtendimento
                ref="filtroRef"
                :filtersReset="filtersReset"
                @update-filtro="updateFiltro"
            />
        </lateral-content>
    </div>
</template>

<script>
/********* services *********/
import AtendimentoService from '@/services/AtendimentoService.js';
import ColaboradorService from '@/services/ColaboradorService.js';
import EmpresaService from '@/services/vendas/empresa/EmpresaService.js';
const AtendimentoManage = () => import('@/components/vendas/atendimento/AtendimentoManage.vue');
import FiltroAtendimento from '@/components/vendas/atendimento/abas-list/FiltroAtendimento.vue';
import Message from '@/models/Message';
import MapasGoogleMapsModal from '@/components/shared/maps/MapasGoogleMapsModal.vue';
import { cutString } from '@/functions/Util';

export default {
    components: {
        FiltroAtendimento,
        AtendimentoManage,
        MapasGoogleMapsModal,
    },
    props: {
        reloadData: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            atendimentoList: [],

            service: new AtendimentoService(this.$http, this.$router),
            colaboradorService: new ColaboradorService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),

            table_fields: [],

            empresaList: [],
            empresaSelected: [],
            empresaLoading: false,

            colaboradorList: [],
            colaboradorSelected: [],
            colaboradorLoading: false,

            msgs: [],
            isLoading: false,
            isEmpty: false,
            dataIsEmpty: false,
            debouncedOnSearch: null,

            column: 'datahorainc',
            order: 'desc',

            filtros: {
                empresa: [],
                vendedor: [],
                motivosAtendimento: [],
                cliente: null,
                funil: null,
                etapa: [],
                propriedade: null,
                area: null,
                talhoes: [],
                cultura: null,
                cultivares: [],
                fasesFenologicas: [],
                tiposDeAgroVisitas: [],
                assuntosAgroVisitas: [],
                safras: [],
                datainicial: this.minusWeeks(new Date(), 4),
                datafinal: this.addWeeks(new Date(), 4),
                observacao: '',
                search: '',
            },
            filtersReset: false,

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },

            showParametrizacao: false,
            showFilter: false,

            showModalAtendimentoManage: false,
            uuid: '',

            locationEditorOpen: false,
            center: { lat: 0, lng: 0 },
            started: false,
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-atendimento');
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'atendimentos' },
            });
        } else {
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
            this.carregarEmpresas('');
            this.carregarDados();
        }
    },
    watch: {
        filtros: {
            deep: true,
            handler: function () {
                this.$emit('filtros', this.filtros);
            },
        },
        reloadData(val) {
            if (val) this.carregarDados(this.pagination.currentPage);
        },
    },
    methods: {
        minusWeeks(date, weeks) {
            date.setDate(date.getDate() - 7 * weeks);
            return date;
        },
        addWeeks(date, weeks) {
            date.setDate(date.getDate() + 7 * weeks);
            return date;
        },
        onClearFilters() {
            this.$root.confirm({
                message: this.$t('msg-confirm-limpar-filtros'),
                onConfirm: () => {
                    this.clearFilter();
                },
            });
        },
        clearFilter() {
            this.filtersReset = true;

            this.colaboradorSelected = [];
            this.empresaSelected = [];
            this.filtros.vendedor = [];
            this.filtros.empresa = [];
            this.filtros.idempresa = null;
            this.filtros.colaborador = [];
            this.filtros.motivosAtendimento = [];
            this.filtros.cliente = null;
            this.filtros.propriedade = null;
            this.filtros.area = null;
            this.filtros.talhoes = [];
            this.filtros.cultura = null;
            this.filtros.cultivares = [];
            this.filtros.fasesFenologicas = [];
            this.filtros.tiposDeAgroVisitas = [];
            this.filtros.assuntosAgroVisitas = [];
            this.filtros.safras = [];
            this.filtros.datainicial = this.minusWeeks(new Date(), 4);
            this.filtros.datafinal = this.addWeeks(new Date(), 4);
            this.filtros.observacao = '';
            this.filtros.search = '';
            this.$refs.search.cleanSearch();

            setTimeout(() => {
                this.filtersReset = false;
                this.showFilter = false;
                this.carregarDados();
            }, 1000);
        },
        updateFiltro(filtro) {
            this.filtros[filtro.nomeFiltro] = filtro.valor;
        },
        pesquisar() {
            if (this.validateDatas()) {
                this.showFilter = false;
                setTimeout(() => {
                    this.carregarDados();
                }, 1000);
            }
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        onSearch(value) {
            this.filtros.search = this.removeAcentos(value);
            this.carregarDados();
        },

        carregarDados(currentPage = 1) {
            this.isLoading = true;

            this.$emit('liberaExpostacao', false);
            this.filtros.datainicial = this.filtros.datainicial
                ? this.$moment(this.filtros.datainicial).format('YYYY-MM-DD')
                : null;

            this.filtros.datafinal = this.filtros.datafinal
                ? this.$moment(this.filtros.datafinal).format('YYYY-MM-DD')
                : null;

            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.service
                .findAll(
                    this.filtros,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage
                )
                .then(this.mapItems)
                .then((value) => {
                    this.atendimentoList = value;
                    this.dataIsEmpty = this.atendimentoList.length <= 0;
                })
                .catch((e) => {
                    this.atendimentoList = [];
                    console.error('Erro ao carregar Atendimentos.', e);
                    this.dataIsEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-dados-geral');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;

                    this.isEmpty = this.dataIsEmpty;
                    this.started = true;
                    this.$emit('liberaExpostacao', !this.isEmpty);
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            this.$emit('changeLimit', body.totalElements);

            return body.content.map((a) => {
                return {
                    uuid: a.uuid,
                    id: a.idAtendimento,
                    codigo: a.idAtendimentoErp,
                    observacao: cutString(a.observacao, 20),
                    latitude: a.checks.latitudecheckin,
                    longitude: a.checks.longitudecheckin,
                    'data-do-atendimento': a.dataAtendimento,
                    datahoraFinalizado: a.datahoraFinalizado,
                    situacao: a.situacao,
                    etapa: a.etapa ? a.etapa.nome : '---',
                    'motivo-atendimento': a.motivoAtendimento
                        ? a.motivoAtendimento.descricao
                        : '---',
                    cliente: a.cliente ? cutString(a.cliente.nome, 20) : '---',
                    colaborador: a.usuario ? a.usuario.nome : '---',
                    contato: a.contato ? a.contato.nome : '---',
                    propriedade: a.propriedade ? a.propriedade.nome : '---',
                    area: a.area ? a.area.descricao : '---',
                    talhao: a.talhao ? a.talhao.descricao : '---',
                    safra: a.safra ? a.safra.descricao : '---',
                    cultura: a.cultura ? a.cultura.descricao : '---',
                    cultivar: a.cultivar ? a.cultivar.descricao : '---',
                    fasefenologica: a.faseFenologica ? a.faseFenologica.descricao : '---',
                    'ven-tipo-agrovisita': a.tipoAgroVisita ? a.tipoAgroVisita.descricao : '---',
                    'assunto-visita': a.assuntoAgroVisita ? a.assuntoAgroVisita.descricao : '---',
                };
            });
        },
        showMessage(type, message) {
            this.msgs.push(new Message(type, message, true));
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
        /*
            @84626
            retornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
            retorna todas as empresas
        */
        carregarEmpresas(search = '') {
            this.empresaLoading = true;
            this.empresaService
                .findList(search)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(
                            `[ATENDIMENTO] Erro status ${r.status} ao carregar empresas.`
                        );
                        console.error(`[ATENDIMENTO] Mensagem: ${r.message}`);
                    } else {
                        this.empresaList = r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                rsocial: e.rsocial,
                            };
                        });
                    }
                })
                .catch((e) => {
                    this.empresaList = [];
                    console.error('[ATENDIMENTO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresaLoading = false;
                });
        },
        updateEmpresa(empresa) {
            this.empresaSelected = empresa;

            this.colaboradorSelected = [];
            this.colaboradorList = [];

            this.filtros.vendedor = [];

            this.filtros.empresa =
                this.empresaSelected.length == 0 ? [] : this.empresaSelected.map((e) => e.id);

            this.carregarColaboradores('');
            this.carregarDados();
        },
        carregarColaboradores(searchQuery) {
            this.colaboradorLoading = true;

            const empresa =
                this.empresaSelected.length > 0 ? this.empresaSelected.map((e) => e.id) : [];

            this.colaboradorService
                .findListAssociatedIdsEmpresa(searchQuery, empresa)
                .then((value) => {
                    this.colaboradorList = value.content;
                })
                .catch((e) => {
                    this.colaboradorList = [];
                    console.error('Erro ao realizar pesquisa de colaboradores.', e);
                })
                .finally((f) => {
                    this.colaboradorLoading = false;
                });
        },
        updateColaborador(colaborador) {
            this.colaboradorSelected = colaborador;
            this.filtros.vendedor =
                this.colaboradorSelected.length == 0
                    ? []
                    : this.colaboradorSelected.map((e) => e.id);
            this.carregarDados();
        },
        ChangeTokanban() {
            this.$emit('changeTab', 1);
        },
        validateDatas() {
            let valido = true;
            let inicio = this.$moment(this.filtros.datainicial);
            let fim = this.$moment(this.filtros.datafinal);

            if (fim.isBefore(inicio)) {
                this.$root.showMessage('error', 'msg-erro-data-inicial-final', true);
                valido = false;
            }

            return valido;
        },
        showModalEdit(uuid) {
            this.uuid = uuid;
            this.showModalAtendimentoManage = true;
        },
        openLocationEditor(atendimento) {
            this.center.lat = +atendimento.latitude;
            this.center.lng = +atendimento.longitude;
            this.locationEditorOpen = true;
        },
        containsLocation(atendimento) {
            return atendimento != null && atendimento.latitude != 0 && atendimento.longitude != 0;
        },
        onCancelLocationEditor() {
            this.locationEditorOpen = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.list {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
}
.filters-bar {
    display: flex;
    padding: 20px 0 10px 0;
    .filters-bar-form {
        flex-grow: 1;
    }
    .filters-bar-actions {
        padding: 16px 0 2px 10px;
        display: flex;
        align-items: stretch;
    }
    @media screen and (max-width: 850px) {
        flex-direction: column;
        .filters-bar-actions {
            align-self: center;
        }
    }
}

.icon-handle {
    svg {
        width: 20px;
        height: 20px;
    }
}
.link {
    flex: 1;
}
.container {
    display: flex;
    align-items: center;
}
.manage-content {
    padding: 20px;
}

.location-icon:hover {
    color: $primary-color-hover;
    cursor: pointer;
}
.location-icon {
    color: $primary-color;
    &.disabled {
        opacity: 0.3;
    }
}
@media screen and (max-width: 850px) {
    .filters-bar-actions {
        justify-content: center;
    }
}
</style>
